import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";

import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription(calendarMark: number[] | null | undefined) {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [units] = useParameter<number>("@units");
  const [cbotDate] = useParameter<number>("@cbot_date");

  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");
  const [commodityValue, setCommodityValue] = useParameter<number>("@commodities");
  const [refYearvalue, setRefYearValue] = useParameter<number>("@ref_year");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendarMark || [],
      "@commodities": commodityValue,
      "@units": units,
      "@ref_year": refYearvalue,
      "@cbot_date": cbotDate,
    });
  }, [title, subtitle, calendarMark, commodityValue, units, refYearvalue, cbotDate, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      // setCommodityDisplay((parameters["@commodities_display"].value as string[]).map(Number)[0]);
      setCommodityValue((parameters["@commodities"].value as string[]).map(Number)[0]);
      setRefYearValue((parameters["@ref_year"].value as string[]).map(Number)[0]);
    },
    [setCommodityDisplay, setCommodityValue, setRefYearValue]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
